<template>
	<div>
		<apexchart
			type="line"
			:options="chartOptions"
			:series="series"
			width="750"
			height="505"
		/>
	</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
/* eslint-disable */
export default {
	components: {
		apexchart: VueApexCharts,
	},
	props: {
		series: {
			default: () => [],
			type: Array,
		},
		chartOptions: {
			default: () => {},
			type: Object,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/apexCharts/dashed.vue